module.exports = __webpack_public_path__ + "img/CellCycle-BRME_GSE179572.f04dbd81.png";